import _objectDestructuringEmpty from '@babel/runtime-corejs3/helpers/objectDestructuringEmpty';
import _extends from '@babel/runtime-corejs3/helpers/extends';
import React__default from 'react';
import classNames from 'classnames';
import styles from './867551be402ddd479d309b090ca9bad4014d3249648d4aff8080c85bf49e3a1f.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import '../../icons/index.es.js';
import useTranslation from '../../utils/Translation/de13cef5749fcd5a6a2788a56fd20c6a15d546ad2713851a9b628cd5aa481529.cfe-internal.js';
import LockIcon from '../../icons/components/8eecf4a9a928b31204fd2313be45ed821b9bb5402dfccae153bf16445da10ea8.cfe-internal.js';

var ReadOnlyText = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var classes = classNames(styles.caption, styles.helperText);
  var _useTranslation = useTranslation(),
    translate = _useTranslation.translate;
  return /*#__PURE__*/React__default.createElement("div", _extends({}, rest, {
    ref: ref,
    className: classes,
    "aria-hidden": true
  }), /*#__PURE__*/React__default.createElement(LockIcon, {
    size: "small",
    className: styles.readOnlyIcon
  }), translate('readOnly'));
});

export { ReadOnlyText as default };
